// :cow: Cosmose CONFIDENTIAL :iso:
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@coa/app/core/services/config.service';
import { AuthService } from '@coa/app/libs/auth/auth-service/services/auth.service';

export const AUTH_SERVICE_PROVIDER = {
  provide: AuthService,
  deps: [HttpClient, ConfigService],
  useFactory: (httpClient: HttpClient, configService: ConfigService) => {
    return new AuthService(
      httpClient,
      configService.getConfig().apiRoot,
      configService.getConfig().apiKey,
    );
  },
};
